export default __webpack_public_path__ + "477ebb6512e17d3bdab18d20ed3eb1f0.svg";